import styled from 'styled-components';

import {FormLabel} from './FormLabel';
import {Icon} from '../../elements/Icon/Icon';

export const WordFix = styled(FormLabel)`
    background: var(--form-labeled-affix-background-color);
    border: 1px solid var(--form-labeled-affix-border-color);
    color: var(--label-text-color-200);
    font-size: var(--text-size-default);
    line-height: var(--height-form-control);
    margin: 0;

    padding: 0 var(--padding-form-control);
    height: var(--height-form-control);
    line-height: var(--height-form-control);
    display: block;
    text-align: center;
    cursor: pointer;

    ${Icon.Wrapper} svg {
        padding-bottom: 3px;
    }
`;

export const LabeledPrefix = styled(WordFix)`
    border-radius: var(--radius-form-control) 0 0 var(--radius-form-control);
    border-right: none;
`;
export const LabeledSuffix = styled(WordFix)`
    border-left: none;
    border-radius: 0 var(--radius-form-control) var(--radius-form-control) 0;
`;
